function scroll2(width) {
    const link               = $('.js-scroll-link');
    const linkAlt            = $('.js-scroll-link-alt');
    let scrollToOffsetTop    = -120;
    let scrollToOffsetTopAlt = -97;

    link.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash, {
            offset: scrollToOffsetTop
        });
    });

    linkAlt.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash, {
            offset: scrollToOffsetTopAlt
        });
    });

    $(window).on('load resize', function(){
        if ( window.deviceWidth <= width ) {
            scrollToOffsetTop    = -90;
            scrollToOffsetTopAlt = -90;
        }
        else {
            scrollToOffsetTop    = -120;
            scrollToOffsetTopAlt = -97;
        }
    });

}